<div class="w-full flex flex-col gap-4">
  <div class="w-0 min-w-full flex flex-col gap-1">
    <h2 class="text-lg font-semibold">
      {{ 'auth.setPassword.title' | translate }}
    </h2>
    <p class="text-sm text-gray-600">
      {{ 'auth.setPassword.description' | translate }}
    </p>
  </div>

  <ngx-form-factory
    [form]="form"
    [formFields]="fieldsService.setPasswordFields"
    (keydown.enter)="onSubmit()"
  />

  <div class="flex flex-row items-center justify-between w-full gap-4">
    <button
      type="button"
      class="cursor-pointer hover:text-light-hover transition-all duration-200"
      (click)="onSignOut()"
    >
      {{ 'auth.setPassword.signOut' | translate }}
    </button>
    <app-button
      [text]="'auth.setPassword.submit' | translate"
      (handleClick)="onSubmit()"
      [disabled]="form.invalid || isSaving()"
      size="small"
    ></app-button>
  </div>
</div>
